import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/close.svg'


const _hoisted_1 = { class: "showVipModalContent" }
const _hoisted_2 = { class: "showVipModalInner" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "checkingState"
}
const _hoisted_5 = { class: "checkingText" }
const _hoisted_6 = {
  key: 1,
  class: "unpaidState"
}
const _hoisted_7 = { class: "unpaidText" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "vipSection" }
const _hoisted_10 = { class: "sectionTitle" }
const _hoisted_11 = { class: "vipSection" }
const _hoisted_12 = { class: "sectionTitle" }
const _hoisted_13 = { class: "desc" }
const _hoisted_14 = { class: "vipList" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "recommendTag"
}
const _hoisted_17 = { class: "vipBadge" }
const _hoisted_18 = { class: "vipPrice" }
const _hoisted_19 = { class: "amount" }
const _hoisted_20 = { class: "unit" }
const _hoisted_21 = { class: "vipDesc" }
const _hoisted_22 = { class: "number" }
const _hoisted_23 = { class: "vipGiveMoney" }
const _hoisted_24 = { class: "number" }
const _hoisted_25 = {
  key: 1,
  class: "checkMark"
}
const _hoisted_26 = {
  key: 2,
  class: "double11-monthly-bonus"
}
const _hoisted_27 = { class: "paySection" }
const _hoisted_28 = { class: "sectionTitle" }
const _hoisted_29 = { class: "payList" }

import { Store } from '@/store';
import message from '@/utils/message';
import request from '@/utils/request';
import { onMounted, onUnmounted, ref } from 'vue'
import { useStore } from 'vuex';
import VipBenefits from './VipBenefits.vue';
import { t, lang } from '@/i18n';

/** Keyword-based fallback map used when id-based lookup misses */

export default /*@__PURE__*/_defineComponent({
  __name: 'showVipModal',
  emits: ["close", "paySuccess"],
  setup(__props, { emit: __emit }) {

const TITLE_FALLBACK_MAP: Record<string, string> = {
  '月': 'Monthly',
  '年': 'Annual',
}
const UNIT_FALLBACK_MAP: Record<string, string> = {
  '月': 'mo',
  '年': 'yr',
}
function keywordFallback(source: string, map: Record<string, string>) {
  for (const key in map) {
    if (source.includes(key)) return map[key]
  }
  return source
}

/** Translate a backend-down vip plan badge by id, then by title keyword, fallback to original */
function tPlanTitle(item: { id: string; title: string }) {
  const key = 'vip.planTitle.' + item.id
  const translated = t(key)
  if (translated !== key) return translated
  if (lang.value !== 'zh') {
    const fallback = keywordFallback(item.title, TITLE_FALLBACK_MAP)
    if (fallback !== item.title) return fallback
  }
  return item.title
}

/** Translate a backend-down price unit by id, then by unit keyword, fallback to original */
function tPriceUnit(id: string, unit: string) {
  const key = 'vip.priceUnit.' + id
  const translated = t(key)
  if (translated !== key) return translated
  if (lang.value !== 'zh') {
    const fallback = keywordFallback(unit, UNIT_FALLBACK_MAP)
    if (fallback !== unit) return fallback
  }
  return unit
}

const store = useStore<Store>()

const emit = __emit

const vipPrices = ref<Array<{
  id: string,
  title: string,
  date: number,
  price: number,
  giveMoney: number,
  priceUnit: string,
  recommend?: true,
}>>([])

onMounted(async () => {
  request.get('https://api.studying1v1.com/video/vipTypeList').then(res => {
    if (res.data) {
      vipPrices.value = res.data;
      console.log('sssssss', vipPrices)
      let isFindRecommend = false;
      res.data.forEach((item: any) => {
        if (item.recommend) {
          selectedVip.value = item.id
          isFindRecommend = true;
        }
      })
      if (!isFindRecommend) {
        selectedVip.value = Object.keys(res.data)[0];
      }
    }
  })
})

const selectedVip = ref<string>('yearly')
const selectedPay = ref<'alipay' | 'wechat'>('alipay')
const orderId = ref<number | null>(null)
const checkStatus = ref<'idle' | 'checking' | 'unpaid'>('idle')

const closeModal = () => {
  emit('close')
}

const handleFocus = async () => {
  if (orderId.value) {
    checkPaymentStatus()
  }
}

const checkPaymentStatus = async () => {
  if (!orderId.value) return
  checkStatus.value = 'checking'

  try {
    const { data } = await request.get('/video/alipay/checkIsPay', {
      params: {
        out_trade_no: orderId.value
      }
    })
    console.log('checkVipPaymentStatus data', data)

    if (data && data.status && data.isPay) {
      message.success(t('vip.paySuccess'))
      emit('paySuccess')
    } else {
      checkStatus.value = 'unpaid'
    }
  } catch (error: any) {
    console.error('checkVipPaymentStatus error', error)
    checkStatus.value = 'unpaid'
  }
}

const handlePay = async (payType: 'alipay' | 'wechat') => {
  const userInfo = store.state.main.userInfo
  if (userInfo && userInfo.id) {
    if (payType === 'alipay') {
      const res = await request.get('https://api.studying1v1.com/video/alipay/createVipOrder?uid=' + userInfo.id + '&vipType=' + selectedVip.value)
      if (res.data) {
        orderId.value = res.data as number;
        console.log('vip orderId', orderId.value)
        window.open('https://api.studying1v1.com/video/alipay/pay?orderId=' + orderId.value, '_blank')
        checkStatus.value = 'checking'
      }
    }
  } else {
    closeModal();
    window.showLoginDialog();
  }
}

onUnmounted(() => {
  window.removeEventListener('focus', handleFocus)
})

window.addEventListener('focus', handleFocus)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#teleport" }, [
    _createElementVNode("div", {
      class: "showVipModal",
      onClick: _withModifiers(closeModal, ["self"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "closeBtn",
            src: _imports_0,
            onClick: closeModal
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('vip.title')), 1),
          (checkStatus.value === 'checking')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "spinner" }, null, -1)),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('vip.checking')), 1)
              ]))
            : (checkStatus.value === 'unpaid')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "unpaidIcon" }, null, -1)),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('vip.unpaid')), 1),
                  _createElementVNode("button", {
                    class: "retryButton",
                    onClick: checkPaymentStatus
                  }, _toDisplayString(_unref(t)('vip.retry')), 1),
                  _createElementVNode("button", {
                    class: "cancelButton",
                    onClick: closeModal
                  }, _toDisplayString(_unref(t)('vip.cancel')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('vip.benefits')), 1),
                    _createElementVNode("div", null, [
                      _createVNode(VipBenefits)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('vip.choosePlan')), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('vip.priceLocked')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vipPrices.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["vipItem", { active: selectedVip.value === item.id, recommend: item.recommend }]),
                          key: item.id,
                          onClick: ($event: any) => (selectedVip.value = item.id)
                        }, [
                          (item.recommend)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(t)('vip.recommend')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(tPlanTitle(item)), 1),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "currency" }, "¥", -1)),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(item.price), 1),
                            _createElementVNode("span", _hoisted_20, "/" + _toDisplayString(tPriceUnit(item.id, item.priceUnit)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createTextVNode(_toDisplayString(_unref(t)('vip.daysBenefits')), 1),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(item.date), 1),
                            _createTextVNode(_toDisplayString(_unref(t)('vip.daysBenefits2')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _cache[4] || (_cache[4] = _createElementVNode("img", { src: "money.png" }, null, -1)),
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(_unref(t)('vip.includes')), 1),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(item.giveMoney), 1),
                              _createTextVNode(_toDisplayString(_unref(t)('vip.credits')), 1)
                            ])
                          ]),
                          (selectedVip.value === item.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3"
                                }, [
                                  _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (item.id === 'monthly')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("div", { class: "bonus-tag" }, "摄影棚 · 双十一特别活动", -1),
                                _createElementVNode("div", { class: "bonus-title" }, "购买1个月 Pro，额外赠送1个月", -1),
                                _createElementVNode("div", { class: "bonus-note" }, "活动截止 2026.11.30", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_15))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('vip.payMethod')), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["payItem", { active: selectedPay.value === 'alipay' }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePay('alipay')))
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("div", { class: "payIcon" }, [
                          _createElementVNode("img", {
                            src: "https://gw.alipayobjects.com/mdn/rms_9e4c39/afts/img/A*Qys_QIJfGPgAAAAAAAAAAAAAARQnAQ",
                            alt: "支付宝"
                          })
                        ], -1),
                        _createElementVNode("div", { class: "payName" }, null, -1)
                      ]))], 2)
                    ])
                  ])
                ]))
        ])
      ])
    ])
  ]))
}
}

})